import { useContent } from '../contexts/ContentContext';
import { useLanguage } from '../contexts/LanguageContext';

// Custom hook to easily get API content with language support
export const useApiContent = () => {
  const { content, loading, getContent, getArrayContent } = useContent();
  const { language } = useLanguage();

  const getText = (section, field) => {
    if (!content || !content[section]) return '';
    const langKey = language === 'ar' ? `${field}_ar` : `${field}_en`;
    return content[section][langKey] || content[section][field] || '';
  };

  const getArray = (section) => {
    return getArrayContent(section) || [];
  };

  return {
    content,
    loading,
    language,
    getText,
    getArray,
    getContent
  };
};

